export type PickupPoint = {
  address: string;
  address2: string;
  city: string;
  county: string;
  distance: number;
  geoLocation: GeoLocation;
  houseNumber: string;
  id: string;
  locationName: string;
  locationType: string;
  openingHours: Array<OpeningHours>;
  organisationName: string;
  pickupPointNumber: string | null;
  postcode: string;
  requiresCustomerAccountId: boolean;
  sanitizedLocationType: string;
};

export type GeoLocation = {
  latitude: number;
  longitude: number;
};

export type OpeningHours = {
  closingTime: string;
  dayOfWeek: string;
  openAllDay: boolean;
  openingTime: string;
};

export type PickupInformation = {
  properties: {
    VERSION: string;
    countryId: string;
    customerAccountId: string;
    customerCity: string;
    customerCountry: string;
    customerFirstName: string;
    customerLastName: string;
    customerMiddleName: string;
    customerPostalCode: string;
    customerStreet: string;
    customerStreet2: string;
    customerStreetNumber: string;
    locationId: string;
    locationName: string;
    locationType: string;
    organisationName: string;
    pickupPointNumber: string;
  };
  serviceName: string;
};
